import React, { useEffect, useState } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import {
  resourcesReports,
  resourcesBranch,
  resourcesUnits,
} from "../../../helpers/backend_helper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import PreviewPDF from "../../../helpers/previewPDF";
import Select from "react-select";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";
import { useParams } from "react-router-dom";
import ButtonHelper from "../../../helpers/ButtonHelper";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const today = dayjs();
const startDate = today.subtract(4, "days").format("YYYY-MM-DD");
const endDate = today.format("YYYY-MM-DD");

const isValidDates = (start, end) => {
  const startDate = dayjs(start);
  const endDate = dayjs(end);

  if (startDate.isAfter(endDate)) {
    toast.warn("La fecha inicio debe ser menor a la fecha fin");

    return false;
  }

  const diffDays = endDate.diff(startDate, "days");
  if (diffDays > 9) {
    toast.warn("Solo se pueden consultar periodos de 10 días");

    return false;
  }

  return true;
};

const DepositsReport = () => {
  const [filtSelect, setFiltSelect] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    route_id: null,
    select: true,
  });
  const [units, setUnits] = useState([]);
  const [unit, setUnit] = useState(null);
  const { report } = useParams();
  const [columnas, setColumnas] = useState();
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [ramales, setRamales] = useState([]);
  const [ramal, setRamal] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: authUser.company_id,
    initDate: startDate,
    endDate: endDate,
    ramal_id: null,
    unit_id: null,
  });
  const filtersOperators = { select: true };
  const [items, setItems] = useState([]);

  useEffect(() => {
    let params = { params: filtSelect };
    resourcesUnits("get", params).then((units) => {
      setUnits(units.data);
    });
  }, []);

  useEffect(() => {
    let params = { params: filters };
    if (filters.initDate && filters.endDate) {
      if (!isValidDates(filters.initDate, filters.endDate)) return;

      setPending(true);

      resourcesReports("show", params, `depositosReport`).then((response) => {
        setItems(response.data);
        setColumnas(response.headers);
        setDataPag(response.pagination);

        setPending(false);
      });
    }
  }, [filters]);

  useEffect(() => {
    let params = { params: filtersOperators };

    resourcesBranch("get", params).then((response) => {
      setRamales(response.data);
    });
  }, []);

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };

    resourcesReports("show", config, `depositosReport`).then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ReporteDepositos.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  const columns = Columns(columnas, filters, ramal, report);
  document.title = "Depositos|Reportes";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle={`Depósitos`}
              columns={columns}
              items={items}
              filterInp={false}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <ButtonHelper
                addButon={false}
                reportButons={true}
                actionReportButon={getReports}
              />

              <PeriodFilterHelper
                setFilters={setFilters}
                filters={filters}
                getReports={getReports}
                modal={modal}
                setModal={setModal}
              />
              <div className="col-sm-2">
                <label className="form-label">Unidad:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  defaultValue={unit}
                  isSearchable={false}
                  name="week"
                  placeholder="Unidades"
                  options={units}
                  getOptionLabel={(option) => `${option.number}`}
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => [
                    setUnit(e),
                    setFilters({ ...filters, unit_id: e ? e.id : null }),
                  ]}
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && <PreviewPDF modalPdf={modal} setModalPdf={setModal} />}
      </div>
    </React.Fragment>
  );
};

export default DepositsReport;
